import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Calendar } from '../types'
import { Meta } from '@/features/filters/types'

import { CALENDARS } from '../constants'

type CalendarsResponse = {
  data: Calendar[]
  meta: Meta
}

const getCalendars = async (params: Meta): Promise<CalendarsResponse> => {
  const response = await fetchAPI({
    path: '/calendars',
    params,
  })

  const data = get(response, 'data.calendars', [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useCalendars = ({
  params = {},
  initialData,
}: {
  params?: Meta
  initialData?: CalendarsResponse
}) => {
  return useQuery<CalendarsResponse, AxiosError>({
    queryKey: [CALENDARS, params],
    queryFn: () => getCalendars(params),
    keepPreviousData: true,
    initialData,
  })
}
